module.exports = __webpack_public_path__ + "Galaxy_S9_icon.svg?71bbd8bcdb92da2249e7759eb9537cf4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Galaxy_S9_icon.svg
// module id = 194
// module chunks = 0